'use client'

import { useEffect } from 'react'
import logger from '@/lib/logger'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    logger.error('Application error caught by error boundary', error, {
      digest: error.digest,
      componentStack: 'error.tsx',
    })
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">
          Nastala chyba
        </h2>
        <p className="mb-6 text-gray-600">
          Omlouváme se, ale nastala neočekávaná chyba.
        </p>
        <button
          onClick={() => reset()}
          className="rounded-md bg-green-600 px-4 py-2 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        >
          Zkusit znovu
        </button>
      </div>
    </div>
  )
}
